// extracted by mini-css-extract-plugin
export default {"data-sources":"DataSources_data-sources__6aXwY"};